import { createIcon } from '@chakra-ui/icons';

export const VideoAssessment = createIcon({
  displayName: 'VideoAssessment',
  viewBox: '0 0 44 44',
  path: [
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0001 43.3445C33.3609 43.3445 42.5705 34.1348 42.5705 22.7741C42.5705 11.4133 33.3609 2.20361 22.0001 2.20361C10.6394 2.20361 1.42969 11.4133 1.42969 22.7741C1.42969 34.1348 10.6394 43.3445 22.0001 43.3445Z"
        fill="#FEF3DF"
      />
      <path
        d="M22 39.8892C26.4733 39.8892 30.0996 39.4057 30.0996 38.8092C30.0996 38.2128 26.4733 37.7292 22 37.7292C17.5267 37.7292 13.9004 38.2128 13.9004 38.8092C13.9004 39.4057 17.5267 39.8892 22 39.8892Z"
        fill="#F6D59D"
      />
      <path
        d="M11.7405 3.76955C11.7402 3.01226 12.0408 2.28585 12.576 1.75015C13.1113 1.21445 13.8374 0.913234 14.5947 0.912842H29.4054C29.7804 0.912972 30.1517 0.986981 30.498 1.1306C30.8445 1.27426 31.1592 1.48474 31.4242 1.75002C31.6892 2.01526 31.8994 2.3302 32.0427 2.67672C32.1861 3.02319 32.2598 3.39454 32.2596 3.76955V35.5267C32.2596 36.2837 31.9589 37.0098 31.4236 37.5452C30.8884 38.0807 30.1625 38.3816 29.4054 38.3819H14.5947C13.8374 38.3816 13.1113 38.0806 12.5759 37.5451C12.0405 37.0096 11.7396 36.2834 11.7395 35.5262L11.7405 3.76955Z"
        fill="white"
      />
      <path
        d="M11.7405 3.76955C11.7402 3.01226 12.0408 2.28585 12.576 1.75015C13.1113 1.21445 13.8374 0.913234 14.5947 0.912842H29.4054C29.7804 0.912972 30.1517 0.986981 30.498 1.1306C30.8445 1.27426 31.1592 1.48474 31.4242 1.75002C31.6892 2.01526 31.8994 2.3302 32.0427 2.67672C32.1861 3.02319 32.2598 3.39454 32.2596 3.76955V35.5267C32.2596 36.2837 31.9589 37.0098 31.4236 37.5452C30.8884 38.0807 30.1625 38.3816 29.4054 38.3819H14.5947C13.8374 38.3816 13.1113 38.0806 12.5759 37.5451C12.0405 37.0096 11.7396 36.2834 11.7395 35.5262L11.7405 3.76955Z"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4755 6.26514H13.5249V32.583H30.4755V6.26514Z"
        fill="#FADFB2"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1077 3.58939L26.0147 3.58887"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0862 3.58895C19.0864 3.71854 19.048 3.84534 18.976 3.95311C18.9041 4.06096 18.8017 4.14499 18.682 4.19465C18.5623 4.24431 18.4305 4.25733 18.3034 4.23207C18.1763 4.2068 18.0595 4.14442 17.9678 4.05273C17.8761 3.96108 17.8137 3.8443 17.7884 3.71719C17.7632 3.58999 17.7762 3.45822 17.8259 3.33852C17.8755 3.21873 17.9596 3.11645 18.0674 3.04453C18.1752 2.97253 18.302 2.9342 18.4316 2.93433C18.5176 2.93415 18.6028 2.95097 18.6823 2.98381C18.7617 3.0167 18.834 3.06492 18.8948 3.12573C18.9556 3.18654 19.0039 3.25876 19.0367 3.33826C19.0695 3.41776 19.0864 3.50292 19.0862 3.58895Z"
        fill="#453924"
      />
      <path
        d="M22 36.7927C22.7234 36.7927 23.3098 36.2063 23.3098 35.4829C23.3098 34.7596 22.7234 34.1731 22 34.1731C21.2766 34.1731 20.6902 34.7596 20.6902 35.4829C20.6902 36.2063 21.2766 36.7927 22 36.7927Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4755 32.5831C29.9017 30.7859 28.7715 29.2175 27.248 28.1047C25.7246 26.9918 23.8868 26.3921 22.0002 26.3921C20.1136 26.3921 18.2758 26.9918 16.7523 28.1047C15.229 29.2175 14.0987 30.7859 13.5249 32.5831H30.4755Z"
        fill="#DCA954"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2174 26.6782C24.1061 26.6504 24.0073 26.5861 23.9367 26.4955C23.8663 26.4051 23.828 26.2936 23.8281 26.1789V24.2761H20.1738V26.1789C20.1736 26.2933 20.1354 26.4046 20.0649 26.4949C19.9945 26.5851 19.896 26.6493 19.7849 26.6772C19.4818 26.752 19.183 26.8439 18.8901 26.9523C19.0219 27.6816 19.4056 28.3413 19.9743 28.8163C20.5429 29.2915 21.2604 29.5518 22.0014 29.5518C22.7424 29.5518 23.4599 29.2915 24.0285 28.8163C24.5972 28.3413 24.981 27.6816 25.1127 26.9523C24.8197 26.8442 24.5207 26.7527 24.2174 26.6782Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5319 20.9509C27.53 20.7259 27.4502 20.5084 27.3061 20.3356C27.162 20.1627 26.9626 20.0451 26.7416 20.0026V19.3701C26.7285 18.1212 26.2233 16.9279 25.3355 16.0493C24.4478 15.1708 23.2493 14.678 22.0003 14.678C20.7513 14.678 19.5528 15.1708 18.665 16.0493C17.7773 16.9279 17.2721 18.1212 17.2591 19.3701V20.0026C17.0285 20.0457 16.8214 20.1709 16.6763 20.3552C16.5312 20.5395 16.4579 20.7701 16.4701 21.0044C16.4822 21.2386 16.579 21.4604 16.7425 21.6286C16.9061 21.7969 17.1251 21.9 17.3589 21.9188C17.5811 22.9853 18.164 23.9428 19.0094 24.6302C19.8548 25.3175 20.911 25.6927 22.0006 25.6927C23.0901 25.6927 24.1464 25.3175 24.9917 24.6302C25.8371 23.9428 26.4199 22.9853 26.6423 21.9188C26.8844 21.897 27.1097 21.7858 27.2742 21.6069C27.4387 21.4279 27.5306 21.194 27.5319 20.9509Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2223 20.5555C20.5495 20.5555 20.8148 20.2902 20.8148 19.963C20.8148 19.6358 20.5495 19.3706 20.2223 19.3706C19.8951 19.3706 19.6299 19.6358 19.6299 19.963C19.6299 20.2902 19.8951 20.5555 20.2223 20.5555Z"
        fill="#453924"
      />
      <path
        d="M23.7782 20.5555C24.1054 20.5555 24.3707 20.2902 24.3707 19.963C24.3707 19.6358 24.1054 19.3706 23.7782 19.3706C23.4511 19.3706 23.1858 19.6358 23.1858 19.963C23.1858 20.2902 23.4511 20.5555 23.7782 20.5555Z"
        fill="#453924"
      />
      <path
        d="M19.4323 22.1358C19.7594 22.1358 20.0247 21.8706 20.0247 21.5433C20.0247 21.2162 19.7594 20.9509 19.4323 20.9509C19.1051 20.9509 18.8398 21.2162 18.8398 21.5433C18.8398 21.8706 19.1051 22.1358 19.4323 22.1358Z"
        fill="#F1CA89"
      />
      <path
        d="M24.5687 22.1358C24.896 22.1358 25.1611 21.8706 25.1611 21.5433C25.1611 21.2162 24.896 20.9509 24.5687 20.9509C24.2416 20.9509 23.9763 21.2162 23.9763 21.5433C23.9763 21.8706 24.2416 22.1358 24.5687 22.1358Z"
        fill="#F1CA89"
      />
      <path
        d="M20.8171 22.9626C21.1681 23.1966 21.5806 23.3214 22.0025 23.3214C22.4243 23.3214 22.8368 23.1966 23.1878 22.9626"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1363 18.1851C27.1432 17.5063 27.0153 16.8329 26.7603 16.2038C26.5052 15.5747 26.1279 15.0023 25.6503 14.5199C25.1727 14.0375 24.6043 13.6546 23.9777 13.3932C23.3512 13.1319 22.679 12.9973 22.0002 12.9973C21.3214 12.9973 20.6492 13.1319 20.0227 13.3932C19.3962 13.6546 18.8277 14.0375 18.35 14.5199C17.8724 15.0023 17.4952 15.5747 17.2401 16.2038C16.985 16.8329 16.8572 17.5063 16.864 18.1851V19.7654C17.4772 19.6116 18.0462 19.3173 18.5262 18.906C19.0062 18.4945 19.384 17.9771 19.6297 17.3947C21.8456 18.885 24.7661 18.5801 27.1363 18.1851Z"
        fill="white"
      />
      <path
        d="M27.1363 18.1851C27.1432 17.5063 27.0153 16.8329 26.7603 16.2038C26.5052 15.5747 26.1279 15.0023 25.6503 14.5199C25.1727 14.0375 24.6043 13.6546 23.9777 13.3932C23.3512 13.1319 22.679 12.9973 22.0002 12.9973C21.3214 12.9973 20.6492 13.1319 20.0227 13.3932C19.3962 13.6546 18.8277 14.0375 18.35 14.5199C17.8724 15.0023 17.4952 15.5747 17.2401 16.2038C16.985 16.8329 16.8572 17.5063 16.864 18.1851V19.7654C17.4772 19.6116 18.0462 19.3173 18.5262 18.906C19.0062 18.4945 19.384 17.9771 19.6297 17.3947C21.8456 18.885 24.7661 18.5801 27.1363 18.1851Z"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8394 16.6045C19.0403 16.9245 19.3104 17.1955 19.6298 17.3975"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8696 11.3487C27.6856 11.3487 28.347 10.6872 28.347 9.87127C28.347 9.0553 27.6856 8.3938 26.8696 8.3938C26.0536 8.3938 25.3921 9.0553 25.3921 9.87127C25.3921 10.6872 26.0536 11.3487 26.8696 11.3487Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
